import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import qs from 'qs';
import styled from '@emotion/styled';
import { Flex, Text } from 'rebass';
import get from 'lodash/get';
import { css } from 'styled-components';
import ResetPasswordFinishForm from './components/ResetPasswordFinishForm';
import theme from '../../_styles/theme';
import StylingUtils from '../../_app/utils/stylingUtils';
import { MOBILE_BREAKPOINT } from '../../_styles/breakpoints';
import { SUBDOMAIN, toHex } from '../../_app/utils/otherUtils';
import { OrganizationBrief } from '../../eventListing/components/OrganizationBrief';
import { ResetPasswordFinishSuccess } from './components/ResetPasswordFinishSuccess';
import EventBrief from '../../signIn/components/EventBrief';

const Container = styled(Flex)`
  flex-direction: row;
  min-height: 100vh;
  width: 100vw;
  max-width: 100%;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
  }
`;

const LeftPart = styled(Box)`
  position: relative;
  width: 44%;
  min-height: 100%;
  ${props =>
    props.backgroundimage
      ? `
      background-image: url(${props.backgroundimage});
      background-position: top left;
      background-repeat: no-repeat;
    `
      : `background-color: ${props.bodycolor}`};

  padding: 150px 56px 70px 53px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 100%;
    height: auto;
    padding: 60px 25px 75px 30px;
  }
`;

const EventContainer = styled(Box)`
  position: relative;
  z-index: 2;
  // max-height: calc(100vh - 65px);
  overflow-y: auto;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: auto;
  }
`;

const RightPart = ({ children, bckg, gradient }) => (
  <Flex
    css={css`
      position: relative;
      flex-direction: column;
      width: 56%;
      height: auto;
      background: ${gradient || bckg || theme.colors.bgLight};
      padding-top: 75px;
      @media (max-width: ${MOBILE_BREAKPOINT}px) {
        width: 100%;
        padding-top: 0;
        min-height: 300px;
      }
      ${StylingUtils.animationFadeIn()}
    `}
  >
    {children}
  </Flex>
);

const Card = styled(Flex)`
  background-color: ${theme.colors.card};
  border-radius: 10px;
  padding: 30px 47px 30px 38px;

  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 14px 16px -6px rgba(0, 0, 0, 0.43);
  min-height: 520px; // temp fix

  overflow-y: hidden;
  ${StylingUtils.animationFadeIn()}
`;

const CardHeader = styled(Text)`
  margin-bottom: 13px;
  font-size: ${theme.fontSizes[6]}px;
  font-weight: ${theme.fontWeights.heading};
  color: ${theme.colors.textDark};
`;

const CardText = styled(Text)`
  font-size: ${theme.fontSizes[2]}px;
  font-weight: ${theme.fontWeights.body};
  color: ${theme.colors.textDarkSecondary};
  line-height: 22px;
`;
const HeaderFixBlock = styled(Box)`
  position: absolute;
  top: -20px;
  right: 0;
  width: 24px;
  height: 24px;
  background-color: #000;
`;

@inject(
  'authStore',
  'eventBriefStore',
  'organizationsStore',
  'homeStore',
  'eventsStore',
)
@observer
class ResetPasswordFinishPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      showSuccess: false,
    };
  }

  async componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    const {
      history,
      match: {
        params: { event_id: eventSlug },
      },
      eventBriefStore: { getEventBrief },
      // eventsStore: { getOrganizationEvents },
      // homeStore: { setActiveOrganization },
      // organizationsStore: { getOrganizationBySlug },
      authStore: { isAuthenticated, redirectAuthenticated },
    } = this.props;

    if (eventSlug) await getEventBrief({ eventId: eventSlug });

    if (isAuthenticated) {
      await redirectAuthenticated(history, null, true);
    }
    // await getOrganizationBySlug(SUBDOMAIN, async org => {
    //   await setActiveOrganization(org);
    //   await getOrganizationEvents(org.id);
    // });
  }

  async componentDidUpdate(prevProps) {
    const {
      organizationsStore: { isLoading },
      homeStore: { activeOrganization },
      eventsStore: { events },
      match: {
        params: { event_id: eventSlug },
      },
      history,
      eventBriefStore: { getEventBrief },
    } = this.props;

    const shouldRedirectToEventContext =
      events.length === 1 &&
      events[0].slug !== get(prevProps, 'match.params.event_id');

    if (shouldRedirectToEventContext) {
      history.push(
        `/reset-password-finish/${events[0].slug}${history.location.search}`,
      );
    }

    if (eventSlug !== get(prevProps, 'match.params.event_id')) {
      await getEventBrief({ eventId: eventSlug });
    }

    if (!activeOrganization && !isLoading) {
      await this.handleNoOrg();
    }
  }

  async componentWillUnmount() {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.authStore.resetPasswordMessage = '';
    window.removeEventListener('resize', this.updateWindowDimensions);

    const {
      eventBriefStore: { clearStore },
    } = this.props;

    await clearStore();
  }

  handleNoOrg = async () => {
    const {
      eventsStore: { getOrganizationEvents },
      homeStore: { setActiveOrganization },
      organizationsStore: { getOrganizationBySlug },
    } = this.props;

    getOrganizationBySlug(SUBDOMAIN, async org => {
      setActiveOrganization(org);
      const events2 = getOrganizationEvents(org.id);
      if (events2.length === 1) {
        this.handleRedirect(events2[0]);
      }
    });
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  handleSubmit = async val => {
    const {
      history: {
        location: { search },
      },
      authStore: { resetPassword },
    } = this.props;
    console.log(search);
    const parsed = qs.parse(search, { ignoreQueryPrefix: true });
    const headers = {
      client: parsed.client || parsed['amp;client'],
      uid: parsed.uid || parsed['amp;uid'],
      'access-token': parsed['access-token'] || parsed['amp;access-token'],
    };

    // eslint-disable-next-line no-return-await
    return await resetPassword(
      {
        ...val,
        headers,
      },
      () => {
        this.setState({ showSuccess: true });
      },
      error => error,
    );
  };

  render() {
    const { width, showSuccess } = this.state;

    const {
      authStore: { isLoading },
      homeStore: { activeOrganization },
      eventsStore: { events, getClosestEvent },
      match: {
        params: { event_id: eventSlug },
      },
      eventBriefStore: { noUpcomming, isLoading: isLoadingBrief, event },
    } = this.props;

    let closestFutureEvent;
    if (events && events.length > 0) {
      if (eventSlug) {
        closestFutureEvent = event;
      } else {
        closestFutureEvent = getClosestEvent(events);
      }
    }

    const signInRedirectPath =
      events && events.length === 1
        ? `/sign-in/${events[0].slug}`
        : '/?signintab=true';

    let customTheme;
    if (closestFutureEvent) {
      customTheme = closestFutureEvent.event_custom_theme;
    }

    const isMobile = width <= MOBILE_BREAKPOINT;

    const {
      buttons_bg: buttonsBg,
      buttons_text_color: buttonsTextColor,
      event_brief_text: eventBriefText,
      event_brief_bg: eventBriefBg,
      event_brief_gradient_top: eventBriefGrTop,
      event_brief_gradient_bottom: eventBriefGrBottom,
      landing_page_bckg_img: landingPageBgImg,
      landing_page_body: landingPageBody,
      header_font_family: headerFontFamily,
    } = customTheme || {};

    const rightBoxGradient =
      eventBriefGrTop && eventBriefGrBottom
        ? `linear-gradient(
            to bottom,
            ${toHex(eventBriefGrTop)},
            ${toHex(eventBriefGrBottom)}
          );`
        : null;

    const bodyColor = landingPageBody
      ? toHex(landingPageBody)
      : theme.colors.backgroundDarker;

    const primaryColor =
      activeOrganization && activeOrganization.dominant_color
        ? toHex(activeOrganization.dominant_color)
        : theme.colors.textSecondary;

    const mainColor = toHex(buttonsBg) || primaryColor;

    const orgName = get(activeOrganization, 'name');
    const orgDescription = get(activeOrganization, 'description');

    return (
      <Container>
        <LeftPart
          bodycolor={bodyColor}
          backgroundimage={landingPageBgImg && landingPageBgImg.url}
        >
          <Card>
            {showSuccess ? (
              <ResetPasswordFinishSuccess
                signInRedirectPath={signInRedirectPath}
                fontFamily={theme.fonts.body}
                buttonsTextColor={toHex(buttonsTextColor)}
                primaryColor={mainColor}
              />
            ) : (
              <>
                <CardHeader fontFamily={theme.fonts.body}>
                  <FormattedMessage id="resetpassword.setpassword" />
                </CardHeader>
                <CardText minHeight="40px">
                  <FormattedMessage id="resetpassword.setpassword.instruction" />
                </CardText>
                <Box flexGrow={1} height="100%">
                  <ResetPasswordFinishForm
                    onSubmit={this.handleSubmit}
                    isLoading={isLoading}
                    primaryColor={mainColor}
                    buttonsTextColor={toHex(buttonsTextColor)}
                    signInRedirectPath={signInRedirectPath}
                  />
                </Box>
              </>
            )}
          </Card>
        </LeftPart>
        <RightPart bckg={toHex(eventBriefBg)} gradient={rightBoxGradient}>
          {eventSlug ? (
            <EventContainer>
              <EventBrief
                isLoading={isLoadingBrief}
                event={closestFutureEvent}
                noUpcomming={noUpcomming}
                isMobile={isMobile}
              />
            </EventContainer>
          ) : (
            <OrganizationBrief
              orgDescription={orgDescription}
              orgName={orgName}
              themeElements={{
                headerFontFamily,
                buttonsBg: toHex(buttonsBg),
                briefTextHex: toHex(eventBriefText),
              }}
            />
          )}
          {!isMobile && <HeaderFixBlock />}
        </RightPart>
      </Container>
    );
  }
}

export default ResetPasswordFinishPage;
